/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Import_Subtitles_Complete_ToastInputs */

const en_editor_import_subtitles_complete_toast = /** @type {(inputs: Editor_Import_Subtitles_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle import complete`)
};

const fr_editor_import_subtitles_complete_toast = /** @type {(inputs: Editor_Import_Subtitles_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des sous-titres terminee`)
};

const de_editor_import_subtitles_complete_toast = /** @type {(inputs: Editor_Import_Subtitles_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelimport abgeschlossen`)
};

const it_editor_import_subtitles_complete_toast = /** @type {(inputs: Editor_Import_Subtitles_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione sottotitoli completata`)
};

const ru_editor_import_subtitles_complete_toast = /** @type {(inputs: Editor_Import_Subtitles_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт субтитров завершен.`)
};

const es_editor_import_subtitles_complete_toast = /** @type {(inputs: Editor_Import_Subtitles_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de subtítulos completada`)
};

const zh_cn2_editor_import_subtitles_complete_toast = /** @type {(inputs: Editor_Import_Subtitles_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕导入完成`)
};

const ja_editor_import_subtitles_complete_toast = /** @type {(inputs: Editor_Import_Subtitles_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕のインポートが完了しました`)
};

const hi_editor_import_subtitles_complete_toast = /** @type {(inputs: Editor_Import_Subtitles_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक आयात पूर्ण हो गया`)
};

const pt_pt2_editor_import_subtitles_complete_toast = /** @type {(inputs: Editor_Import_Subtitles_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de legendas concluída`)
};

/**
* | output |
* | --- |
* | "Subtitle import complete" |
*
* @param {Editor_Import_Subtitles_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_import_subtitles_complete_toast = /** @type {((inputs?: Editor_Import_Subtitles_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Import_Subtitles_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_import_subtitles_complete_toast(inputs)
	if (locale === "de") return de_editor_import_subtitles_complete_toast(inputs)
	if (locale === "it") return it_editor_import_subtitles_complete_toast(inputs)
	if (locale === "ru") return ru_editor_import_subtitles_complete_toast(inputs)
	if (locale === "es") return es_editor_import_subtitles_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_import_subtitles_complete_toast(inputs)
	if (locale === "ja") return ja_editor_import_subtitles_complete_toast(inputs)
	if (locale === "hi") return hi_editor_import_subtitles_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_import_subtitles_complete_toast(inputs)
	return en_editor_import_subtitles_complete_toast(inputs)
});